module.exports = __webpack_public_path__ + "img/puzzle_breaker.328cb029.png";